import { render, staticRenderFns } from "./Compose.ModulePanel.vue?vue&type=template&id=2ce017a0&scoped=true&"
import script from "./Compose.ModulePanel.vue?vue&type=script&lang=js&"
export * from "./Compose.ModulePanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce017a0",
  null
  
)

export default component.exports